import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { CustomerForm } from "./components/customer/customer.form.r";
import { setApiErrorUrl, setApiUrl } from "@phoenixreisen/gateway";
import { VisitorList } from "./components/visitor/visitor.list.r";
import { Schedules } from "./components/schedules/schedules.r";
import { PaymentForm } from "./components/payment/payment.r";
import { SuccessPage } from "./components/finish/finish.r";
import { Summary } from "./components/summary/summary.r";
import { Entry } from "./components/entry/page.r";
import { createRoot } from "react-dom/client";
import { Layout } from "./layout/layout.r";
import DateTime from "date-and-time";
import React from "react";
import "./index.scss";
(() => {
    const { env } = process;
    DateTime.locale("de");
    setApiErrorUrl(env.API_ERROR);
    setApiUrl(`${env.GATEWAY}/call-json-service`);
    createRoot(document.getElementById("root")).render(React.createElement(Router, null,
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/kunde", element: React.createElement(Layout, { noWrapper: false },
                    React.createElement(CustomerForm, null)) }),
            React.createElement(Route, { path: "/besucher", element: React.createElement(Layout, { noWrapper: false },
                    React.createElement(VisitorList, null)) }),
            React.createElement(Route, { path: "/zusammenfassung", element: React.createElement(Layout, { noWrapper: false },
                    React.createElement(Summary, null)) }),
            React.createElement(Route, { path: "/zahlung", element: React.createElement(Layout, { noWrapper: false },
                    React.createElement(PaymentForm, null)) }),
            React.createElement(Route, { path: "/danke", element: React.createElement(Layout, { noWrapper: false },
                    React.createElement(SuccessPage, null)) }),
            React.createElement(Route, { path: "/:type", element: React.createElement(Layout, { noWrapper: false },
                    React.createElement(Schedules, null)) }),
            React.createElement(Route, { path: "/", element: React.createElement(Layout, { noWrapper: false },
                    React.createElement(Entry, null)) }))));
})();
